export const MY_PROFILE_ACCOUNT_SETTINGS = "my-profile-account-settings";
export const MY_PROFILE_PERSONAL_DETAILS_LINK =
  "my-profile-personal-details-link";
export const MY_PROFILE_PERSONAL_DETAILS_LABEL =
  "my-profile-personal-details-label";
export const MY_PROFILE_LOGIN_INFORMATION_LINK =
  "my-profile-login-information-link";
export const MY_PROFILE_LOGIN_INFORMATION_LABEL =
  "my-profile-login-information-label";
export const MY_PROFILE_SECURITY_PREFERENCES_LINK =
  "my-profile-security-preferences-link";
export const MY_PROFILE_SECURITY_PREFERENCES_LABEL =
  "my-profile-security-preferences-label";
export const MY_PROFILE_SITE_ACCESS_LINK = "my-profile-site-access-link";
export const MY_PROFILE_SITE_ACCESS_LABEL = "my-profile-site-access-label";
